// Created in order to avoid error importing this component directly on cofee script
import Banner from 'zignal-landscape/lib/Banner';
export default Banner;
